import { render, staticRenderFns } from "./OrdersListingItem.vue?vue&type=template&id=6cde2c7b&scoped=true"
import script from "./OrdersListingItem.vue?vue&type=script&lang=ts"
export * from "./OrdersListingItem.vue?vue&type=script&lang=ts"
import style0 from "./OrdersListingItem.vue?vue&type=style&index=0&id=6cde2c7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cde2c7b",
  null
  
)

export default component.exports